import { Component } from "@angular/core";

interface ProductCategory {
    title: string;
    description: string;
    image?: string;
    route?: string;
    alt?: string;
}

@Component({
    selector: "app-product-category",
    templateUrl: "./product-category.component.html",
    styleUrls: ["./product-category.component.scss"],
})
export class ProductCategoryComponent {
    productCategories: ProductCategory[] = [
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/AzHBLbJAym1cNKq1uPAK9Aer0UwoOvZsdmtCzLHV.jpg',
            title: "Interactive Flat Panels (IFP)",
            description: "Smart, powerful and classroom-ready panels with built-in AI tools and premium touch performance.",
            route: "/interactive-flat-panel-smart-classroom",
            alt: "Virsa smart classroom interactive flat panel"
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/fVxptF9b35oseaJ83BXjOEG7ltWb24One84GLDK4.jpg',
            title: "IFP Protection (Shutter)",
            description: "Automated shutter mechanism for safe device protection in labs, ICT rooms and classrooms.",
            route: "/shutter-system",
            alt: "Virsa interactive flat panel shutter accessory"
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/DX5KLrFNJnGzkV3pyUEVmHCGo8W5qpVQQaWRFWLR.jpg',
            title: "All-in-One PCs",
            description: "High-performance school & office desktops with compact design and enterprise reliability.",
            route: "/all-in-one-pc-computers-accessories",
            alt: "Virsa All-in-One PC for college"
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/MYN9DZgKhN1rsxlXKVNieqFNeXU9ZXYn5vf2HWxD.jpg',
            title: "LMS Platform",
            description: "A complete digital learning ecosystem for teachers, students, schools and admins.",
            route: "/lms",
            alt: "Virsa digital classroom solution LMS platform"
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/e7JfR9nxK33xojuTA23L5BmBvxLBByRfzRJp3raN.jpg',
            title: "K-12 Digital Content",
            description: "Curriculum-aligned lessons, videos, worksheets and assessments for grades KG–12.",
            route: "/k-12-digital-content",
            alt: "Virsa digital classroom solution K-12 content"
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/QTzghJRcvn6kGpobxiSqtr5rObdRg6AyVkuoV9zY.jpg',
            title: "Digital E-Library",
            description: "A rich, interactive digital library platform offering age-appropriate books, stories, videos, and learning activities to foster reading and literacy skills for children.",
            route: "/digital-e-library",
            alt: "Virsa digital classroom solution E-Library"
        },
    ];
}
